<!--
   Created by qing on 2020/8/19
   Des: 
-->
<template>
	 <!-- v-if="!loading" -->
  <div
   
	 v-loading="loading"
    class="app-list-page"
    v-wechat-title="title">
    <div class="advertising-container">
      <div
        class="advertising-item"
        v-for="item in advertisingList"
        :key="item.recordId"
        @click="onClickAdvertising(item)">
        <div class="advertising-item-wrapper">
          <img :src="item.imageUrl" alt="">
          <van-icon name="cross" @click.stop="read(item)"/>
        </div>

      </div>
    </div>
    <div class="app-list-container" v-if="allAppList.length || starAppList.length">
      <van-cell
        v-if="starAppList.length"
        title="星标应用"
        custom-class="app-body"
        :border="false">
        <div
          class="app-item-list"
          slot="label">
          <div
            v-for="item in starAppList"
            :key="item.appId"
            class="app-item"
            @click="onClickApp(item)">
            <div
              class="icon menu-icon"
              :style="{backgroundColor: item.iconColor}"
              @touchstart="startTap(item)"
              @touchend="endTap(item)">
              <i
                v-if="item.appIconType === 'SYSTEM'"
                class="app-icon"
                :class="item.appIcon"
                :style="{color: !item.iconColor || item.iconColor === '#ffffff' ? '#333333' : '#ffffff'}"
              ></i>
              <img
                v-else
                style="height: 50px; width: 50px; object-fit: cover; border-radius: 10px; background-color: #ffffff"
                :src="item.appIcon"
                alt="">
            </div>
            <div class="maintain-tag" v-if="item.maintainFlag === 'YES'">
              维护中
            </div>
            <div class="text">
              {{item.appName}}
            </div>
          </div>
          <div
            class="app-item add-item"
            @click="onClickAddStar">
            <div class="icon menu-icon">
              <i class="app-icon el-icon-plus"></i>
            </div>
            <div class="text">
              添加星标
            </div>
          </div>
        </div>
      </van-cell>

      <van-cell
        v-if="allAppList.length"
        title="所有应用"
        custom-class="app-body"
        :border="false">
        <div
          class="app-item-list"
          slot="label">

          <div
            class="app-item"
            v-for="item in allAppList"
            :key="item.appId"
            @click="onClickApp(item)">
            <div
              class="icon menu-icon"
              :style="{backgroundColor: item.iconColor}"
              @touchstart="startTap(item)"
              @touchend="endTap(item)">
              <i
                v-if="item.appIconType === 'SYSTEM'"
                class="app-icon"
                :class="item.appIcon"
                :style="{color: !item.iconColor || item.iconColor === '#ffffff' ? '#333333' : '#ffffff'}"
              ></i>
              <img
                v-else
                style="height: 50px; width: 50px; object-fit: cover; border-radius: 10px; background-color: #ffffff"
                :src="item.appIcon"
                alt="">
            </div>

            <div class="maintain-tag" v-if="item.maintainFlag === 'YES'">
              维护中
            </div>
            <div class="text">
              {{item.appName}}
            </div>
          </div>
        </div>
      </van-cell>

    </div>

    <div v-else class="apply-no-data">
      <img src="../../../assets/images/empty.png" alt="">
      {{isAdmin ? '您还未创建任何应用' : '您还没有任何可操作应用，联系管理员分配权限'}}
      <van-button
        type="primary"
        class="template-btn"
        size="small"
        style="width: 40%;"
        @click="onclickTemplate">
        去应用中心体验
      </van-button>
    </div>

    <van-popup
      class="setting-star-app-popup"
      v-model="visible"
      get-container="body"
      safe-area-inset-bottom
      :style="{ height: '90%', width: '100%' }"
      round
      closeable
      position="bottom">
      <div class="setting-app-title">
        设置星标应用
      </div>
      <div class="setting-app-item-list">
        <div
          class="setting-app-item"
          v-for="item in allAppList"
          :key="item.appId">
          <div
            class="icon"
            :style="{backgroundColor: item.iconColor}">
            <i
              v-if="item.appIconType === 'SYSTEM'"
              class="app-icon"
              :class="item.appIcon"
              :style="{color: !item.iconColor || item.iconColor === '#ffffff' ? '#333333' : '#ffffff'}"
            ></i>
            <img
              v-else
              style="height: 50px; width: 50px; object-fit: cover; border-radius: 10px; background-color: #ffffff"
              :src="item.appIcon"
              alt="">
          </div>
          <div class="app-info">
            <div class="app-name">
              {{item.appName}}
            </div>
            <div class="app-des">
              {{item.appDes}}
            </div>
          </div>
          <van-button
            plain
            hairline
            :type="item.star ? 'default' : 'info'"
            :color="item.star ? '#5d616f' : ''"
            size="mini"
            @click="onClickStar(item)">
            {{item.star ? '取消星标' : '星标'}}
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>

</template>

<script>
  import {arrayRandomElement, iconList} from "../../../assets/js/Untis";

  export default {
    data() {
      return {
        loading: true,
        advertisingList: [],
        allAppList: [],
        title: '',
        starAppList: [],

        visible: false,
        timer: null,
        startTime: 0,
        endTime: 0
      }
    },
    async created() {

      if (this.$route.params.spaceId && this.$route.params.pageConfigId) {
        // 客户门户加载当前页面
        const pageConfig = await this.$store.dispatch('actionSpacePageConfigDetail', {
          spaceId: this.$route.params.spaceId,
          pageConfigId: this.$route.params.pageConfigId
        }).catch(console.error)
        this.title = pageConfig.pageTitle
      } else {
        // 移动端首页加载当前页面
        this.title = this.$store.getters.company ? this.$store.getters.company.companyName : '所有应用'
      }
      this.$store.dispatch('setPageTitle', this.title)

      this.loading = true
      this.fetchApps()
      this.fetchAdvertisingList()
    },
    computed: {
      isAdmin() {
        const adminInfo = this.$store.getters.adminInfo
        return adminInfo && (adminInfo.creator || adminInfo.topAdmin)
      },
    },
    methods: {
      // 获取广告
      fetchAdvertisingList() {
        this.$store.dispatch('actionAdvertisingList')
          .then(res => {
            this.advertisingList.splice(0, this.advertisingList.length)
            if (res.advertisingList && res.advertisingList.length) {
              this.advertisingList.push(res.advertisingList[0])
            }
          }).catch(console.error)
      },
      fetchApps() {
		  // 修改loading组件 2022年6月30日byzb
        // const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('getApps')
          .then(resultObject => {
            this.allAppList = resultObject.allAppList
            this.starAppList = resultObject.starAppList
            this.handleAppInfo()
          }).catch(console.error)
          .finally(() => {
            this.loading = false
          })
      },
      onClickApp(app) {
        this.$store.commit('UPDATE__APP', app)
        this.$router.push({
          name: 'appHome',
          query: {
            appId: app.appId,
            appName: app.appName
          }
        })
      },
      onClickStar(item) {
        if (item.star) {
          this.$store.dispatch('actionCancelStarApp', {
            appId: item.appId
          }).then(res => {
            this.$toast.success('设置成功')
            this.fetchApps()
          }).catch(console.error)
        } else {
          this.$store.dispatch('actionStarApp', {
            appId: item.appId
          }).then(res => {
            this.$toast.success('设置成功')
            this.fetchApps()
          }).catch(console.error)
        }
      },
      onclickTemplate() {
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('reqNodeSave', {
          userId: this.$store.getters.userId,
          userInfo: this.$store.getters.userInfo,
          company: this.$store.getters.company,
          token: this.$store.state.token,
        })
          .then(res => {
            this.$router.push({
              name: 'templateList',
              query: {
                key: res.nodeKey
              }
            })
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            toast.clear()
          })
      },
      // 添加星标应用
      onClickAddStar() {
        this.visible = true
      },
      onClickAdvertising(item) {
        const aEle = document.createElement('a')
        if (aEle) {
          aEle.href = item.jumpUrl
          aEle.target = '_blank'
          aEle.click()
        }
      },
      read(item) {
        this.$store.dispatch('actionAdvertisingRead', {
          recordId: item.recordId
        })
          .then(res => {
            this.fetchAdvertisingList()
          }).catch(console.error)
      },

      startTap(item) {
        this.startTime = +new Date()
        this.timer = setTimeout(() => {
          // 处理长按事件
            this.$dialog.confirm({
              title: `提示`,
              message: `是否${item.star ? '取消星标' : '设置为星标应用'}`,
              confirmButtonText: `${item.star ? '取消星标' : '设置星标'}`,
              cancelButtonText: '取消'
            }).then(() => {
              this.onClickStar(item)
            }).catch(action => {
            })
        }, 400)
      },

      endTap(item) {
        this.endTime = +new Date()
        clearTimeout(this.timer)
        if (this.endTime - this.startTime < 400 && this.endTime - this.startTime > 100) {
          // 处理点击事件

        }
      },

      // 兼容app没有图标
      handleAppInfo() {

        const appMap = {}
        this.allAppList.forEach(item => {
          if (!item.appIcon || !item.iconColor) {
            appMap[item.appId] = item
          }
        })

        Object.values(appMap).forEach(item => {
          item.appIcon = arrayRandomElement(iconList())
          item.iconColor = arrayRandomElement([
            '#0E9EFF',
            '#00B0C7',
            '#B065ED',
            '#FF8249',
            '#FF627A',
            '#F5B000',
            '#7757FF',
            '#92C534',
            '#9192AB',
          ])

          const app = this.starAppList.filter(f => f.appId === item.appId)[0]
          if (app) {
            app.appIcon = item.appIcon
            app.iconColor = item.iconColor
          }

          this.$store.dispatch("updateApp", {
            appId: item.appId,
            appName: item.appName,
            appDes: item.appDes,
            appImg: item.appImg,
            appIcon: item.appIcon,
            iconColor: item.iconColor
          }).catch(console.error)
        })
      }
    }
  }
</script>

<style lang="less">

  .app-list-page {
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;

    .advertising-container {
      position: relative;

      .advertising-item {
        position: relative;
        width: 100%;
        padding: 0 14px;
        margin: 10px 0;

        .advertising-item-wrapper {
          position: relative;
          width: 100%;
          height: clientwidth / 1.8;
          overflow: hidden;
          cursor: pointer;
          border-radius: 5px;

          img {
            object-fit: cover;
            height: 100%;
            width: 100%;
            transition: transform .3s;
            border-radius: 5px;
          }

          .van-icon {
            position: absolute;
            top: 10px;
            right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            font-size: 14px;
            cursor: pointer;
            color: #fff;
            background-color: rgba(0, 0, 0, 0.3);
            width: 20px;
            height: 20px;
          }

          .read-btn {
            position: absolute;
            bottom: 5px;
            right: 5px;
            color: #333333;
            font-size: 12px;
            padding: 5px 20px;
            background-color: #f6f6f6;
            border-radius: 20px;
            border: 1px solid #fff;
          }
        }
      }
    }

    .app-list-container {

      .van-cell {
        background-color: transparent;
      }

      .van-cell__title {
        background-color: #fff;
        border-radius: 10px;
        width: calc(100% - 20px);
        padding-top: 10px;

        > span {
          margin-left: 20px;
        }

        .van-cell__label {
          width: 100%;
        }
      }

      .app-item-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .app-item {
          position: relative;
          margin: 8px 0;
          padding: 0 8px;
          text-align: center;
          width: 25%;
          height: 100px;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;

          .icon {
            position: relative;
            width: 50px;
            height: 50px;
            border-radius: 10px;

            .app-icon {
              font-size: 36px;
              color: #ffffff;
            }
          }

          .menu-icon {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .text {
            margin-top: 12px;
            line-height: 18px;
            display: -webkit-box;
            font-size: 12px;
            color: #333333;
            width: 100%;
            text-align: center;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            white-space: normal;
            word-break: break-word;
          }

          .maintain-tag {
            position: absolute;
            top: -5px;
            right: -5px;
            line-height: 20px;
            padding: 0 5px;
            background-color: #6ca2ff;
            font-size: 12px;
            color: #ffffff;
            border-radius: 10px;
            transition: all 0.3s;
            border: 2px solid #ffffff;
          }
        }


        .add-item {

          .icon {
            background-color: #f8fafc;
            border: 1px dashed #959699;
          }

          .app-icon {
            font-size: 24px !important;
            color: #333333 !important;
          }
        }
      }
    }

    .apply-no-data {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #fff;

      img {
        width: 300px;
        height: 222px;
        margin-bottom: 20px;
      }

      .template-btn {
        margin-top: 20px;
        color: #4A66FA;
        border-radius: 20px;
        border: 1px solid #4A66FA;
        background-color: #fff;
      }
    }
  }

  .setting-star-app-popup {

    .setting-app-title {
      color: #333;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-bottom: 1px solid #e6e6e6;
    }

    .setting-app-item-list {
      height: calc(100% - 50px);
      overflow: auto;
    }

    .setting-app-item {
      display: flex;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid #e6e6e6;

      >.icon {
        position: relative;
        width: 50px;
        height: 50px;
        border-radius: 10px;
        border: 1px solid #e6e6e6;
        display: flex;
        justify-content: center;
        align-items: center;

        .app-icon {
          font-size: 36px;
          color: #ffffff;
        }
      }

      >.app-info {
        width: calc(100% - 130px);
        margin: 0 10px;

        .app-name {
          font-size: 16px;
          color: #333;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }

        .app-des {
          font-size: 14px;
          color: #7F8389;
          margin-top: 10px;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }
      }

      >.van-button {
        border-radius: 10px;
        width: 56px;
      }
    }
  }
</style>